import router from '../../loader/lib/router';
var DEVMODE_LS_KEY = 'consoleDevMode';
var DEVMODE_HOOK_KEY = 'consoleDevHook';

/**
 * 是否通过调试路由进入
 */
var isDebugRoute = function () {
  // IE 9 用哈希表示路径
  var currentPath = [location.pathname, location.hash].join('').replace(/^\/#/, '');
  return /^\/debug(?:_(?:online|http|https))?/.test(currentPath);
};

/**
 * 模块导出到 seajs 模块和全局变量
 */
var devmode = (window.devmode = {
  /**
   * 判断当前是否在开发模式
   */
  isInDevMode: function () {
    return localStorage.getItem(DEVMODE_LS_KEY) === 'on';
  },
  /**
   * 获取当前状态
   */
  getStatus: function () {
    return status;
  },

  /**
   * 初始化
   */
  init: function () {
    try {
      // 当前已经是开发模式渲染视觉效果
      if (status === 'on') {
        devmode.render();
      }
      // 调试路由切换到开发模式
      if (isDebugRoute()) {
        devmode.enter();
      }

      // 控制台输出开发模式提示
      if (status === 'on') {
        console.log(
          '%c欢迎使用开发模式，开发模式下异常不会收集上报，请尽情调试！如需退出，可使用命令行：%cdevmode.exit()',
          'color: darkgreen;',
          'color: purple; background: #f0f0f0; padding: 2px 4px; border-radius: 2px; font-family: monospace;'
        );
      }
    } catch (err) {
      // 旁路应用，异常不应该阻塞主进程
    }
  },

  /**
   * 进入开发模式
   */
  enter: function (hook) {
    localStorage.setItem(DEVMODE_LS_KEY, 'on');
    status = 'on';
    if (hook) {
      localStorage.setItem(DEVMODE_HOOK_KEY, JSON.stringify(hook));
      if (typeof hook === 'string') {
        location.href = '/' + hook;
      } else
        for (var key in hook) {
          location.href = '/' + key;
          break;
        }
    } else {
      devmode.render();
    }
  },

  /**
   * 退出开发模式，并且重定向到控制台首页
   * 如果是从 /debug 路由进入，不重定向的话，页面刷新之后开发模式又会循环进入了
   */
  exit: function (clearHook) {
    localStorage.removeItem(DEVMODE_LS_KEY);
    if (clearHook) {
      localStorage.removeItem(DEVMODE_HOOK_KEY);
    }
    location.href = '/';
  },

  /**
   * 渲染开发模式的视觉效果，提供明显的标识
   */
  render: function () {
    if (status !== 'on') {
      return;
    }
    if (devmode.hasRendered) {
      return;
    }

    var hookInfo;
    try {
      hookInfo = useHook(JSON.parse(localStorage.getItem(DEVMODE_HOOK_KEY)));
    } catch (err) { }

    // 进入开发模式，取消所有上报
    //insight.shutdown();

    var $logo = $('[class="qc-nav-logo"], [class="logo"]').css({
      width: '140px',
      backgroundColor: 'orange',
      background: 'linear-gradient(90deg, orange, transparent)'
    });

    var $icon = $logo.find('a.qc-logo-inner');
    $icon.css({
      borderRight: 'none',
      verticalAlign: 'middle'
    });

    var $devmode = $(
      [
        '<div class="tc-15-bubble-icon tc-15-triangle-align-start mr20">',
        '<span>开发模式</span>',
        '<div class="tc-15-bubble tc-15-bubble-top">',
        '<div class="tc-15-bubble-inner">',
        (hookInfo || [])
          .map(function (info) {
            return (
              '<p>开发钩子：<a href="' +
              info.config.content +
              '" target="_blank">' +
              info.key +
              '</a></p>'
            );
          })
          .join(''),
        '<p>开发模式中，异常事件不会被收集和上报。<br/><a class="exit-devmode" style="cursor: pointer">退出开发模式</a></p>',
        '</div>',
        '</div>',
        '</div>'
      ].join('')
    ).css({
      fontSize: '14px',
      display: 'inline-block',
      height: '32px',
      lineHeight: '32px',
      margin: '9px 0',
      verticalAlign: 'middle',
      color: 'white',
      cursor: 'default'
    });
    $devmode.delegate('.exit-devmode', 'click', devmode.exit);
    $icon.after($devmode);

    devmode.hasRendered = true;
  }
});
/**
 * 开发模式当前状态：on / off
 */
var status = window.devmode.isInDevMode() ? 'on' : 'off';
function useHook(hook) {
  if (!hook) {
    return null;
  }
  // 为 tea 2.0 app 开通快速通道
  if (typeof hook === 'string') {
    var key = hook;
    hook = {};
    var jsUrl = 'https://wds.tea.local/' + key + '.js';
    hook[key] = { content: jsUrl, component: 'tea2' };
    console.log(
      '%cTea APP 开发钩子已生效%c\n请使用 Whistle 代理到本地开发端口：%cwds.tea.local http://127.0.0.1:8322',
      'background: black; color: yellow; padding: 5px; border-radius: 2px;',
      'background: none; color: inherit;',
      'border: 1px dashed black; padding: 3px 8px; border-radius: 2px; font-family: monospace'
    );
  }
  if (typeof hook !== 'object') {
    return null;
  }
  var hookInfo = [];
  for (var businessKey in hook) {
    var businessConfig = hook[businessKey];
    if (businessConfig) {
      router.use.apply(
        router,
        setupRouter.addJsRoute(businessKey, hook[businessKey])
      );
      hookInfo.push({ key: businessKey, config: businessConfig });
    }
  }
  return hookInfo;
}

export { devmode };
